<template lang="pug">
  v-dialog(v-model="value_" width="1360")
    .white.pa-5
      #print-preview(:class="printClass")
        .cover-page(:style="`background-image: url(${ backgroundImage })`")
          .cover-info
            .contact-data
              h3.current-time {{ title }}, {{ currentTime }}
              h1.primary--text.mt-1 {{ clientName }}

              p.primary--text.mt-8
                span Ihr Ansprechpartner:<br>
                span.font-weight-regular {{ contactData }}

            img.img-tenant-logo(src="@/assets/images/pdf_vkb_logo.svg")
            img.img-spk-verbundhinweis(src="@/assets/images/pdf_spk_verbundhinweis.svg")

        output-section.mt-3(
          :categories="sectionFields || []"
          is-print
        )

        v-expansion-panels.output-section(v-if="printContracts" :value="0" accordion flat tile)
          v-expansion-panel.output-category-panel
            v-expansion-panel-header Erfasste Verträge
            v-expansion-panel-content.pl-3.pt-3(eager)
              v-flex.xs12.consultation--output-category: v-expansion-panels.flat-panels(
                :value="panels"
                flat
                tile
                multiple
              )
                v-expansion-panel.group-panel.mt-4(
                  v-for="(c, i) in contracts"
                  :key="i"
                )
                  v-expansion-panel-header.ml-0.pl-0 {{ c.name }}
                  v-expansion-panel-content.py-3(eager)
                    field-row(
                      v-for="f in c.fields"
                      :key="f.id"
                      :field="f"
                      :label-class="`ml-4`"
                    )

        v-expansion-panels.output-section(v-if="printAngebote" :value="0" accordion flat tile)
          v-expansion-panel.output-category-panel
            v-expansion-panel-header Konzeptverträge - Angebote
            v-expansion-panel-content.pl-3.pt-3(eager)
              v-flex.xs12.consultation--output-category: v-expansion-panels.flat-panels(
                :value="konzeptPanels"
                flat
                tile
                multiple
              )
                v-expansion-panel.group-panel.mt-4(
                  v-for="(c, i) in konzeptContracts"
                  :key="i"
                )
                  v-expansion-panel-header.ml-0.pl-0 {{ c.name }}
                  v-expansion-panel-content.py-3(eager)
                    field-row(
                      v-for="f in c.fields"
                      :key="f.id"
                      :field="f"
                      :label-class="`ml-4`"
                    )

        output-globals.mt-3(v-if="globalFields.length" :fields="globalFields")

      v-row.align-center.mt-2
        v-col(cols="3"): v-btn(
          color="secondary"
          large
          outlined
          @click="$emit('input', false)"
        )
          span.primary--text schließen

        v-col.d-flex.align-center.justify-end(cols="9")
          v-switch.ml-4(
            v-model="printContracts"
            label="Verträge drucken"
          )

          v-switch.ml-4(
            v-model="printNotice"
            label="Notizen drucken"
          )

          v-switch.ml-4(
            v-model="printAngebote"
            label="Angebote drucken"
          )

          v-btn.ml-4(
            color="primary"
            large
            @click="onPrint"
          ) Drucken

</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import { Printd } from 'printd'

import FormMixin from '@/mixins/form'
import Urls from '@/router/urls'

@Component({
  components: {
    FieldRow: () => import('./field-row'),
    OutputSection: () => import('./output-section'),
    OutputGlobals: () => import('./output-globals'),
  },

  mixins: [
    FormMixin
  ],

  watch: {
    value () {
      if (!this.value) {
        return
      }

      this.printNotice = true
      this.printContracts = true
      this.printAngebote = false
      this.loadContracts()
      this.loadContracts(true)
    }
  }
})
export default class KonzeptPrint extends Vue {
  @Prop({ type: Boolean, default: false }) value
  @Prop({ type: [ Number, String ], default: '' }) id
  @Prop({ type: String, default: '' }) title
  @Prop({ type: String, default: '' }) clientName
  @Prop({ type: String, default: '' }) contactData
  @Prop({ type: Array, default: () => [] }) sectionFields
  @Prop({ type: Array, default: () => [] }) globalFields

  printContracts = true
  printNotice = true
  printAngebote = false

  contracts = []
  konzeptContracts = []

  get value_ () {
    return this.value
  }

  set value_ (v) {
    this.$emit('input', v)
  }

  get backgroundImage () {
    if (this.userTenantId === 'VKB') {
      return require('@/assets/images/pdf-vkb-bg.jpg')
    }

    if (this.userTenantId === 'FSOEL') {
      return require('@/assets/images/pdf-fsoel-bg.jpg')
    }

    if (this.userTenantId === 'SAV') {
      return require('@/assets/images/pdf-sav-bg.jpg')
    }

    return ''
  }

  get panels () {
    return this.contracts.map((_, i) => i)
  }

  get konzeptPanels () {
    return this.konzeptContracts.map((_, i) => i)
  }

  get currentTime () {
    return this.formatDateTime(new Date(), 'DD.MM.YYYY')
  }

  get printClass () {
    let classList = []
    if (!this.printNotice) {
      classList.push('hide-all-notice')
    }
    if (!this.printContracts) {
      classList.push('hide-all-contracts')
    }
    return classList
  }

  loadContracts (forKonzept = false) {
    this.$axios
      .get(`${ Urls.Consultation(this.id) }vertraege/`, {
        for_konzept: forKonzept
      })
      .then(res => {
        this.getContractFields(res.data, forKonzept)
      })
      .catch(err => {
        this.$toast.error(err.message, 'Fehler')
      })
  }

  getContractFields (fieldData, forKonzept) {
    if (forKonzept) {
      this.konzeptContracts = []
    } else {
      this.contracts = []
    }
    let fields = []

    if (fieldData.Fields) {
      fields.push(...fieldData.Fields)
    }

    Object.values(fieldData.Locations || {})
      .map(l => {
        if (l.Fields) {
          fields.push(...l.Fields)
        }

        Object.values(l.Buildings || {}).forEach(b => {
          if (b.Fields) {
            fields.push(...b.Fields)
          }
        })
      })

    fields = fields
      .filter((f, i) => !f.hidden && (i === fields.findIndex(f_ => f_.id === f.id)))
      .sort((a, b) => a.sort_index - b.sort_index)
      .map(f => ({
        ...f,
        value: this.getFieldValue(f)
      }))

    fields.forEach(f => {
      if (f.is_vv_nr) {
        let groupName = ''

        const groupFields = fields.filter(f_ => {
          if (f_.category !== f.category || f_.sub_section !== f.sub_section) {
            return false
          }

          if (f_.v_field_identifier === 'VName') {
            groupName = f_.value
          }

          return true
        })

        if (forKonzept) {
          this.konzeptContracts.push({
            name: `${ f.value } (${ groupName })`,
            fields: groupFields
          })
        } else {
          this.contracts.push({
            name: `${ f.value } (${ groupName })`,
            fields: groupFields
          })
        }
      }
    })
  }

  onPrint () {
    const d = new Printd({
      parent: document.body
    })

    const colors = {
      primary: '#024589',
      danger: '#F44336'
    }

    const cssMixins = (new Array(17))
      .fill(0)
      .map((_, i) => `
        .mt-${ i } { margin-top: ${ i * 4 }px !important; }
        .mb-${ i } { margin-bottom: ${ i * 4 }px !important; }
        .ml-${ i } { margin-left: ${ i * 4 }px !important; }
        .mr-${ i } { margin-right: ${ i * 4 }px !important; }
        .my-${ i } { margin-top: ${ i * 4 }px !important; margin-bottom: ${ i * 4 }px !important; }
        .mx-${ i } { margin-left: ${ i * 4 }px !important; margin-right: ${ i * 4 }px !important; }
        .pt-${ i } { padding-top: ${ i * 4 }px !important; }
        .pb-${ i } { padding-bottom: ${ i * 4 }px !important; }
        .pl-${ i } { padding-left: ${ i * 4 }px !important; }
        .pr-${ i } { padding-right: ${ i * 4 }px !important; }
        .py-${ i } { padding-top: ${ i * 4 }px !important; padding-bottom: ${ i * 4 }px !important; }
        .px-${ i } { padding-left: ${ i * 4 }px !important; padding-right: ${ i * 4 }px !important; }
      `)
      .join('\n')

    const flexCols = (new Array(12))
      .fill(0)
      .map((_, i) => `
        .col-${ i } { position: relative; display: inline-block; max-width: ${ i * 100 / 12 }% !important; page-break-inside: avoid; vertical-align: top; }
        .col-sm-${ i } { position: relative; display: inline-block; max-width: ${ i * 100 / 12 }% !important; page-break-inside: avoid; vertical-align: top; }
        .col-md-${ i } { position: relative; display: inline-block; max-width: ${ i * 100 / 12 }% !important; page-break-inside: avoid; vertical-align: top; }
      `)
      .join('\n')

    let cssText = `
      * {
        font-family: "Roboto", sans-serif;
        font-size: 15px;
        line-height: 1;
        text-align: left;
        -webkit-print-color-adjust: exact;
        color-adjust: exact;
      }

      @page {
        margin-top: 30px;
        margin-bottom: 30px;
        color: rgba(0, 0, 0, 0.87);
      }

      h1 {
        font-size: 28px;
      }

      h2 {
        font-size: 24px;
      }

      h3 {
        font-size: 20px;
      }

      h4 {
        font-size: 16px;
      }

      table {
        -webkit-print-color-adjust: exact;
      }

      label {
        display: inline-block;
      }

      .row {
        position: relative;
        display: inline-block;
        margin: 0;
        width: 100%;
        vertical-align: top;
      }

      .col {
        position: relative;
        display: inline-block;
        width: 100%;
        padding: 8px 0;
        page-break-inside: avoid;
        vertical-align: top;
      }

      .print-panel-header {
        position: relative;
        width: 100%;
      }

      .primary--text {
        color: ${ colors.primary } !important;
      }

      .red--text {
        color: ${ colors.danger } !important;
      }

      #print-preview {
        display: block;
      }

      #print-preview .v-expansion-panel {
        position: relative;
        border: none !important;
      }

      #print-preview.hide-all-notice .notice-field-row {
        display: none !important;
      }

      .empty-notice-field {
        display: none !important;
      }

      .output-category-panel {
        page-break-after: always;
      }

      .v-expansion-panel .v-expansion-panel-header {
        background-color: ${ colors.primary };
        border: none;
        color: #fff;
        padding: 16px 30px;
        font-weight: 500;
        width: 100%;
        position: relative;
      }

      .v-expansion-panel .v-expansion-panel-header h4 {
        max-width: calc(100% - 120px);
      }

      .v-expansion-panel .v-expansion-panel-header .v-expansion-panel-header__icon {
        display: none;
      }

      .flat-panels .v-expansion-panel .v-expansion-panel-header {
        background-color: transparent;
        padding: 0;
      }

      .theme--light.v-expansion-panels.flat-panels .v-expansion-panel.group-panel .v-expansion-panel-header {
        color: ${ colors.primary };
        font-size: 16px;
        padding: 3px 18px;
        min-height: 22px;
      }

      .category-header {
        position: relative;
      }

      .traffic-image {
        position: absolute;
        left: auto;
        top: 2px;
        right: -6px;
        width: 90px;
        transform: rotate(180deg);
      }

      .traffic-image.left-aligned {
        position: absolute;
        top: 2px;
        right: auto;
        left: 34px;
      }

      .flat-panels .traffic-image {
        position: absolute;
        top: 10px;
        left: auto;
        right: 0px;
      }

      .flat-panels .traffic-image.left-aligned {
        position: absolute;
        top: 10px;
        right: auto;
        left: 28px;
      }

      .field-value {
        max-width: 100%;
        text-align: right;
      }

      .hint-text {
        font-size: 14px;
        color: #666;
      }

      .info-tooltip {
        display: none;
      }

      .font-weight-bold {
        font-weight: bold;
      }

      .cover-page {
        position: relative;
        height: calc(100vh - 40px);
        page-break-after: always;
        background-position: center;
        background-repeat: none;
        background-size: cover;
      }

      .cover-page .cover-image {
        max-width: 100%;
      }

      .cover-page .cover-info {
        position: absolute;
        background-color: #B1D1E5;
        left: 0;
        bottom: 0;
        right: 0;
      }

      .cover-page .contact-data {
        background-color: #DEEAF8;
        font-weight: bold;
        max-width: 65%;
        min-height: 18vh;
        padding: 3% 5%;
        white-space: pre;
        margin-bottom: 10%;
      }

      .cover-page .contact-data h1 {
        font-size: calc(2.4vh);
      }

      .cover-page .contact-data h3 {
        font-size: calc(1.6vh);
      }

      .cover-page .contact-data p span {
        font-size: calc(1.4vh);
      }

      .font-weight-regular {
        font-weight: normal;
      }

      .cover-page .current-time {
        color: #048DBB;
        padding-right: 10%;
        white-space: pre-wrap;
      }

      .cover-page .img-tenant-logo {
        position: absolute;
        top: 0;
        right: 0;
        max-width: 35%;
        transform: translate(0, -50%);
      }

      .cover-page .img-spk-verbundhinweis {
        position: absolute;
        right: 8%;
        bottom: 7%;
        max-width: 20%;
      }

      .input-customer-pref {
        position: absolute;
        top: 14px;
        left: 112px;
        right: 0;
        display: inline-block;
        font-weight: normal;
        white-space: pre-line;
      }

      .input-customer-pref p {
        position: relative;
        top: -10px;
        display: inline-block;
        vertical-align: top;
      }

      .debug-info {
        display: none !important;
      }

      .position-relative {
        position: relative !important;
        vertical-align: top;
      }

      .hint-text {
        font-size: 14px;
        color: #666;
      }

      .hint-text svg {
        width: auto;
        height: 18px;
        min-width: 18px;
      }

      .svg-radar {
        width: 24px
      }

      .grey--text {
        color: #9e9e9e !important
      }

      .font-weight-regular {
        font-weight: normal;
      }

      span.transparent {
        opacity: 0;
      }
    `
    // for (const node of [...document.querySelectorAll('style')]) {
    //   cssText += node.innerHTML
    // }

    d.print(document.getElementById('print-preview'), [
      `${ cssText } ${ cssMixins } ${ flexCols }`,
      'https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900',
      'https://cdn.jsdelivr.net/npm/@mdi/font@4.x/css/materialdesignicons.min.css'
    ])
  }
}
</script>

<style lang="sass">
.consultation--base-data
  a.nav-location
    display: flex
    align-items: center

    &.disabled
      color: #666
      pointer-events: none

.cover-page
  position: relative
  min-height: 1560px
  background-position: center
  background-repeat: none
  background-size: cover
  height: 100vh

  @media screen and (max-width: 1400px)
    min-height: calc((100vw - 90px) * 1.18)

  .cover-image
    max-width: 100%

  .cover-info
    position: absolute
    background-color: #B1D1E5
    left: 0
    bottom: 0
    right: 0

  .contact-data
    background-color: #DEEAF8
    font-weight: bold
    max-width: 75%
    min-height: 28vh
    padding: 3% 5%
    white-space: pre
    margin-bottom: 10%

    p
      font-size: calc(1.6vh)

    h1
      font-size: calc(2.6vh)

    h3
      font-size: calc(1.8vh)

  .current-time
    color: #048DBB
    padding-right: 10%
    white-space: pre-wrap

  .img-tenant-logo
    position: absolute
    top: 0
    right: 0
    max-width: 35%
    transform: translate(0, -50%)

  .img-spk-verbundhinweis
    position: absolute
    right: 8%
    bottom: 7%
    max-width: 20%
</style>
